import { useState } from 'react';

import { ResourceCostChartWidget } from './_components/ResourceCostChartWidget';
import { useWorkloadResourceCostChartData } from './_hooks/useWorkloadResourceCostChartData';
import { GPU_FIELDS } from './constants';

const GPU_COST_TOOLTIP_TEXT =
  'Cost per requested GPU based on GPU compute spend divided by requested GPU count.';

export const GpuCostChartWidget = () => {
  const [costRate, setCostRate] = useState<'hourly' | 'daily' | 'monthly'>(
    'daily'
  );
  const {
    data,
    averageCost,
    isLoading,
    error,
    refetch,
    timeZone,
    isRangeSupported,
  } = useWorkloadResourceCostChartData(costRate, GPU_FIELDS);

  return (
    <ResourceCostChartWidget
      title="GPU cost"
      testId="gpu-cost-card"
      metricLabel="Cost per requested GPU"
      metricInfoTooltip={GPU_COST_TOOLTIP_TEXT}
      metricTestId="gpu-cost-metrics-box"
      failedToLoadTitle="Failed to load GPU cost"
      hasOfferingBreakdown
      costRate={costRate}
      onCostRateChange={setCostRate}
      data={data}
      averageCost={averageCost}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      timeZone={timeZone}
      isRangeSupported={isRangeSupported}
      chartTestId="gpu-cost-chart"
      tooltipTestId="gpu-cost-tooltip"
      unsupportedRangeTestId="gpu-cost-card-unsupported-range"
    />
  );
};
